import { render, staticRenderFns } from "./discussList.vue?vue&type=template&id=67495700&scoped=true"
import script from "./discussList.vue?vue&type=script&lang=js"
export * from "./discussList.vue?vue&type=script&lang=js"
import style0 from "./discussList.vue?vue&type=style&index=0&id=67495700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67495700",
  null
  
)

export default component.exports